// extracted by mini-css-extract-plugin
export default {"card":"RzUuhI","header":"xIMkvV","badges":"PAEQH2","name":"aUdRMW","description":"xtn5DS","meta":"HXNJJq","tags":"j01GY3","tag":"fAQCeb","actions":"SsCorR","link":"Pmc6IC"};